import { type ErrorFilter } from "../types/noiseFilter"

// Returns true if the error should be suppressed.
export const LOGS_NOISE_FILTERS: ErrorFilter[] = [
    // Didomi SDK logs console errors for IAB GVL vendors before the vendor list
    // has loaded their names (race condition in sdk.privacy-center.org — not fixable from our side).
    ({ message }) => message.startsWith("Didomi - "),

    ({ message }) => message.startsWith("Unable to parse JWT token"),
    ({ message }) => message.includes("Script error."),

    // Vercel BotID worker calls OffscreenCanvas.getContext() with unsupported context types
    // (e.g. "webgpu") on older Safari/iOS, producing unhandled TypeErrors from a blob: worker.
    // Non-actionable from our side — BotID still works via fallback.
    ({ message }) => message.includes("OffscreenCanvas.getContext"),
]
